export default class ParallelActions {
	constructor() {
		this.count = 0;
		this.ended = 0;
		this.seqL = [];
	}

	add(action) {
		this.seqL.push(action);
		this.count++;
	}

	start(completeAction) {
		if (this.seqL.length > 0) {
			for (var i = 0; i < this.seqL.length; i++) {
				this.seqL[i](() => {
					this.ended++;
					if (this.ended == this.count) {
						if (completeAction != null) {
							completeAction();
						}
					}
				});
			}
		} else {
			if (completeAction != null) {
				completeAction();
			}
		}
	}
}
